import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Flex, Text } from '@chakra-ui/react';
import React from 'react'
import { LdsEllipsis } from '../styles';

const ModalDialog = ({ focusButton, onClose, isOpen, enviarInfoPNota, loadingButton }) => {
  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={focusButton}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
      enviarInfoPNota={enviarInfoPNota}
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader mx='auto'>Confira as informações!</AlertDialogHeader>
        <AlertDialogCloseButton boxShadow="none !important" />
        <AlertDialogBody>
          <Flex>
            <Text>Total de caixas: </Text>
            <Text ml="5px" id="totalAlert"></Text>
          </Flex>
          <Flex>
            <Text>Total de itens: </Text>
            <Text ml="5px" id="totalAlertItens"></Text>
          </Flex>
          <Flex>
            <Text>Peso: </Text>
            <Text ml="5px" id="pesoTotalGramas"></Text>
            <Text ml="5px" id="kg"></Text>
          </Flex>
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button
            boxShadow="none !important"
            w="70px"
            colorScheme="red"
            onClick={onClose}
          >
            Não
          </Button>
          <Button
            boxShadow="none !important"
            w="70px"
            ref={focusButton}
            colorScheme="green"
            onKeyPress={(e) =>
              e.key == "Enter" ? enviarInfoPNota(e) : null
            }
            onClick={(e) => {
              enviarInfoPNota(e);
            }}
            ml={3}
          >
            {loadingButton ? (
              <LdsEllipsis class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </LdsEllipsis>
            ) : (
              <span>Sim</span>
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default ModalDialog